import {Completion, completeFromList, snippetCompletion as snip} from "@codemirror/autocomplete"


const globals: readonly Completion[] = [
  /*
  "__annotations__", "__builtins__", "__debug__", "__doc__", "__import__", "__name__",
  "__loader__", "__package__", "__spec__",
  */
  "False", "None", "True"
].map(n => ({label: n, type: "constant"})).concat([
/*  
  "ArithmeticError", "AssertionError", "AttributeError", "BaseException", "BlockingIOError",
  "BrokenPipeError", "BufferError", "BytesWarning", "ChildProcessError", "ConnectionAbortedError",
  "ConnectionError", "ConnectionRefusedError", "ConnectionResetError", "DeprecationWarning",
  "EOFError", "Ellipsis", "EncodingWarning", "EnvironmentError", "Exception", "FileExistsError",
  "FileNotFoundError", "FloatingPointError", "FutureWarning", "GeneratorExit", "IOError",
  "ImportError", "ImportWarning", "IndentationError", "IndexError", "InterruptedError",
  "IsADirectoryError", "KeyError", "KeyboardInterrupt", "LookupError", "MemoryError",
  "ModuleNotFoundError", "NameError", "NotADirectoryError", "NotImplemented", "NotImplementedError",
  "OSError", "OverflowError", "PendingDeprecationWarning", "PermissionError", "ProcessLookupError",
  "RecursionError", "ReferenceError", "ResourceWarning", "RuntimeError", "RuntimeWarning",
  "StopAsyncIteration", "StopIteration", "SyntaxError", "SyntaxWarning", "SystemError",
  "SystemExit", "TabError", "TimeoutError", "TypeError", "UnboundLocalError", "UnicodeDecodeError",
  "UnicodeEncodeError", "UnicodeError", "UnicodeTranslateError", "UnicodeWarning", "UserWarning",
  "ValueError", "Warning", "ZeroDivisionError"
].map(n => ({label: n, type: "type"}))).concat([
*/
  "bool", "bytearray", "bytes", "complex", "float", "int", "list",
  "map", "object", "range", "set", "str", "super", "tuple", "type"
].map(n => ({label: n, type: "class"}))).concat([
/*  
  "bool", "bytearray", "bytes", "classmethod", "complex", "float", "frozenset", "int", "list",
  "map", "memoryview", "object", "range", "set", "staticmethod", "str", "super", "tuple", "type"
].map(n => ({label: n, type: "class"}))).concat([
*/
  "abs", "any", "all", "any", "bin", "chr", "callable", "delattr", "dict", "dir",
  "divmod", "enumerate", "eval", "exec", "exit", "filter",
  "format", "getattr", "globals", "hasattr", "hash", "hex", "id", "isinstance",
  "iter", "len", "locals", "max", "min", "next", "oct", "open",
  "ord", "pow", "print", "property", "repr", "reversed", "round", "setattr", "slice",
  "sorted", "sum", "vars", "zip"
/*
].map(n => ({label: n, type: "class"}))).concat([
  "abs", "aiter", "all", "anext", "any", "ascii", "bin", "breakpoint", "callable", "chr",
  "compile", "delattr", "dict", "dir", "divmod", "enumerate", "eval", "exec", "exit", "filter",
  "format", "getattr", "globals", "hasattr", "hash", "help", "hex", "id", "input", "isinstance",
  "issubclass", "iter", "len", "license", "locals", "max", "min", "next", "oct", "open",
  "ord", "pow", "print", "property", "quit", "repr", "reversed", "round", "setattr", "slice",
  "sorted", "sum", "vars", "zip"
*/  
].map(n => ({label: n, type: "function"})))

export const snippets: readonly Completion[] = [
  snip("def ${name}(${params}):\n\t${}", {
    label: "def",
    detail: "function",
    type: "keyword"
  }),
  snip("for i in range(${count}):\n\t${}", {
    label: "for",
    detail: "counting loop",
    type: "keyword"
  }),
  snip("for ${name} in ${collection}:\n\t${}", {
    label: "for",
    detail: "loop",
    type: "keyword"
  }),
  snip("while ${}:\n\t${}", {
    label: "while",
    detail: "loop",
    type: "keyword"
  }),
  snip("try:\n\t${}\nexcept ${error}:\n\t${}", {
    label: "try",
    detail: "/ except block",
    type: "keyword"
  }),
  snip("if ${}:\n\t\n", {
    label: "if",
    detail: "block",
    type: "keyword"
  }),
  snip("if ${}:\n\t${}\nelse:\n\t${}", {
    label: "if",
    detail: "/ else block",
    type: "keyword"
  }),
  snip("class ${name}:\n\tdef __init__(self, ${params}):\n\t\t\t${}", {
    label: "class",
    detail: "definition",
    type: "keyword"
  }),
  snip("import ${module}", {
    label: "import",
    detail: "statement",
    type: "keyword"
  }),
  snip("from ${module} import ${names}", {
    label: "from",
    detail: "import",
    type: "keyword"
  }),

  snip("play(${note}, beats=1)", {
    label: "play",
    detail: "play a note",
    type: "function"
  }),
  snip("play([${note1}, ${note2}, ${note3}], beats=1)", {
    label: "play",
    detail: "play a chord",
    type: "function"
  }),
  snip("rest(${beats})", {
    label: "rest",
    detail: "rest",
    type: "function"
  }),
  snip("rewind(${beats})", {
    label: "rewind",
    detail: "rewind the playhead",
    type: "function"
  }),
  snip("fastForward(${beats})", {
    label: "fastForward",
    detail: "move playhead forward",
    type: "function"
  }),
  snip("moveTo(${beats})", {
    label: "moveTo",
    detail: "move the playhead",
    type: "function"
  }),
  snip("getPlayhead()", {
    label: "getPlayhead",
    detail: "get the value of the playhead",
    type: "function"
  }),
  snip("getBeat()", {
    label: "getBeat",
    detail: "get the current beat",
    type: "function"
  }),
  snip("getMeasure()", {
    label: "getMeasure",
    detail: "get the current measure",
    type: "function"
  }),
  snip("with lowpass(${frequency}):\n\t", {
    label: "with lowpass",
    detail: "add a lowpass filter effect",
    type: "block"
  }),
  snip("with highpass(${frequency}):\n\t", {
    label: "with highpass",
    detail: "add a highpass filter effect",
    type: "block"
  }),
  snip("with transpose(${steps}):\n\t", {
    label: "with transpose",
    detail: "change notes up or down",
    type: "block"
  }),
  snip("with bend(${cents}):\n\t", {
    label: "with bend",
    detail: "pitch up or down",
    type: "block"
  }),
  snip("with pan(${value}):\n\t", {
    label: "with pan",
    detail: "pan left or right (-1.0 to 1.0)",
    type: "block"
  }),
  snip("with gain(${value}):\n\t", {
    label: "with gain",
    detail: "increase or decrease volume",
    type: "block"
  }),
]

/// Autocompletion for built-in Python globals and keywords.
export const globalCompletion = completeFromList(globals.concat(snippets))
